import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSaleOrders(ctx, queryParams) {
      console.log('queryOrder order', queryParams)
      const payload = {
        "pagination": {
        "total": 0,
        "current": 0,
        "pageSize": 0
        },
        "search": {
        "name": "",
        "startPrice": null,
        "endPrice": null,
        "shopId": queryParams.q,
        "categoryId": null
        },
        "sort": {
        "predicate": "",
        "reverse": true
        }
        }
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SaleOrder/GetOrderList` , payload)
          .then(response => {
            console.log('res', response)
            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = 'saleOrderId',
              sortDesc = false,
            } = queryParams
  
            const queryLowered = q.toLowerCase()
            
  
            const filteredData = response.data.data.list.filter(
              user =>
            
                user
                // user && user.productName.toLowerCase().includes(queryLowered)  || user.categoryName.toLowerCase().includes(queryLowered)
            )
            console.log('res2', filteredData)
            const sortedData = filteredData.sort(sortCompare(sortBy))
            if (sortDesc) sortedData.reverse()
            resolve({
              data: paginateArray(sortedData, perPage, page),
              totalCount: filteredData.length,
            })
          })
          .catch(error => reject(error))
      })
    },
    fetchSaleOrder(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/SaleOrder/GetById`, {
            params: {
              saleOrderId: id,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addSaleOrder(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SaleOrder/AddOrUdpate`, { userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
